export default {
    view: {
        title: 'Mega-trend',
        pageTitle: 'VIEW - MEGA-TREND'
    }
}
